import isNull from "lodash-es/isNull"
import isString from "lodash-es/isString"
import isUndefined from "lodash-es/isUndefined"

function getStorageItemValue<T>(value: string | null): T | null {
    if (isNull(value) || isUndefined(value)) return null

    try {
        return JSON.parse(value) as T
    } catch {
        return value as T
    }
}

function setStorageItemValue<T>(value: T): string {
    return isString(value) ? value : JSON.stringify(value)
}

const storageUtils = { getStorageItemValue, setStorageItemValue }

export { storageUtils }
